<template>
  <div class="filter-wrapper">
    <div
      class="item"
      :class="{active: index === activeIndex}"
      v-for="(value, index) in tabList"
      :key="index"
      @click="activeTab(index)"
    >
      <span>{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: Array,
    index: Number,
  },
  data() {
    return {
      activeIndex: this.index,
    };
  },
  methods: {
    activeTab(index) {
      this.activeIndex = index;
      let menuName = this.$route.name;
      this.$emit("active-tab", index);
      this.$router.push({
        name: menuName,
        query: {index: index},
      });
    },
  },
  watch: {
    index(value) {
      this.activeIndex = value;
    },
  },
};
</script>

<style scoped>
.filter-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 1rem 0;
}
.item {
  width: 100%;
  height: 4rem;
  border: 1px solid #e6e6e6;
  border-bottom: 1px solid #f83f1b;
  background-color: #f4f4f4;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-left: -1px;
  cursor: pointer;
}
.item.active {
  border: 1px solid #f83f1b !important;
  border-bottom: 0 !important;
  background-color: transparent;
  z-index: 2;
}
.active span {
  color: #f83f1b;
  font-weight: bold;
}
</style>
